import styled from '@emotion/styled';
import ContactFormMenu from '@ep/components/ContactForm/ContactFormMenu';
import { Body } from '@ep/components/Typography';
import theme from '@ep/theme';
import { Gcms_Post } from '@ep/types/gatsbyTypes';
import React, { useState } from 'react';

export interface GridFilterProps {
  defaultTableData: Gcms_Post[];
  tableData: Gcms_Post[];
  setTableData: (table: Gcms_Post[]) => void;
  defaultTopic?: string | null | undefined;
}

const CategorySelect = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0rem 0 4rem;
  > div {
    margin: 0 0.5rem 0 0rem;
  }
  ${theme.mediaQueries.tablet} {
    text-align: left;
    align-items: flex-start;
    flex-direction: column;
    > div {
      margin: 0;
      width: 100%;
      button {
        width: 100%;
      }
    }
  }
  ${theme.mediaQueries.mobile} {
    text-align: left;
    align-items: flex-start;
    flex-direction: column;
    > div {
      margin: 0;
      width: 100%;
      button {
        width: 100%;
      }
    }
  }
`;

const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  > div {
    margin: 0 0.8rem 0 0;
  }
  ${theme.mediaQueries.tablet} {
    flex-direction: column;
    width: 100%;
    > div {
      margin: 0;
      width: 100%;
      div {
        margin: 0;
      }
      button {
        width: 100%;
      }
    }
  }
  ${theme.mediaQueries.mobile} {
    flex-direction: column;
    width: 100%;
    > div {
      margin: 0;
      width: 100%;
      div {
        margin: 0;
      }
      button {
        width: 100%;
      }
    }
  }
`;

const pluck = (objs: Gcms_Post, property: string) =>
  objs.map((obj: Gcms_Post) => obj[property]);

const unique = (arr: Gcms_Post[]) =>
  arr.filter((el, i, array) => array.indexOf(el) === i);

export interface menuItems {
  value: string;
  short: string;
}
const buildMenu = (data: Gcms_Post[] | null) => {
  let menuItems: menuItems[] = [{ value: 'All Topics', short: 'All Topics' }];
  unique(pluck(data, 'postTopic')).forEach((label: string) => {
    menuItems.push({ value: label, short: label });
  });
  return menuItems;
};

const buildTagsMenu = (data: Gcms_Post[] | null) => {
  let menuItems: menuItems[] = [{ value: 'All Tags', short: 'All Tags' }];
  let menues: string[] = [];
  if (data && data.length > 0) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].postTags && data[i].postTags.length > 0) {
        data[i].postTags.forEach((tag: string) => menues.push(tag));
      }
    }
    // to get unique String Array
    unique(menues).forEach((label: string) => {
      menuItems.push({ value: label, short: label });
    });
  }
  return menuItems;
};

export const filterTable = (
  arr: Gcms_Post[],
  key: string,
  value: string,
  isTag?: boolean,
) => {
  if (value === 'All Topics' || value === 'All Tags') {
    return arr;
  }
  let returnArr: Gcms_Post[] = [];
  arr.forEach((item, index) => {
    if (isTag && item[key].length > 0 && item[key].includes(value)) {
      returnArr.push(arr[index]);
    } else if (!isTag && item[key] === value) {
      returnArr.push(arr[index]);
    }
  });

  return returnArr;
};

const GridFilter = ({
  defaultTableData,
  tableData,
  setTableData,
  defaultTopic,
}: GridFilterProps) => {
  const [topicTable, setTopicTable] = useState<Gcms_Post[]>(defaultTableData);
  const [tagTable, setTagTable] = useState<Gcms_Post[]>(defaultTableData);

  const [topic, setTopic] = useState<string>(defaultTopic || 'All Topics');
  const [tag, setTag] = useState<string>('All Tags');

  const [topicMenu, setTopicMenu] = useState<menuItems[]>(buildMenu(tableData));
  const [tagMenu, setTagMenu] = useState<menuItems[]>(buildTagsMenu(tableData));

  const setTopics = (paramTopic: string) => {
    setTopic(paramTopic);
    let filteredTable;
    if (tag === 'All Tags') {
      filteredTable = filterTable(defaultTableData, 'postTags', paramTopic, true);
    } else {
      filteredTable = filterTable(tagTable, 'postTopic', paramTopic);
    }
    setTopicTable(filteredTable);
    setTableData(filteredTable);
    if (paramTopic === 'All Topics') {
      setTagMenu(buildTagsMenu(defaultTableData));
    } else {
      setTagMenu(buildTagsMenu(filteredTable));
    }
  };

  const setTags = (paramTag: string) => {
    setTag(paramTag);
    let filteredTable;
    if (topic === 'All Topics') {
      filteredTable = filterTable(defaultTableData, 'postTags', paramTag, true);
    } else {
      filteredTable = filterTable(topicTable, 'postTags', paramTag, true);
    }
    setTagTable(filteredTable);
    setTableData(filteredTable);
  };
  return (
    <CategorySelect>
      <SelectContainer>
        <Body>FILTER BY</Body>
        <ContactFormMenu
          options={topicMenu}
          action={e => setTopics(e)}
          initLabel={topic}
          // disabled={tag !== 'All Tags'}
        />
      </SelectContainer>
      {/* {topic !== 'All Topics' && (
        <SelectContainer>
          <Body>TAGS</Body>
          <ContactFormMenu
            options={tagMenu}
            action={e => setTags(e)}
            initLabel={tag}
          />
        </SelectContainer>
      )} */}
    </CategorySelect>
  );
};

export default GridFilter;
